import React from 'react';
import { PersonVitalTimeFrame } from '@redux/person/personTypes';
import { ChartProps } from 'containers/PatientDashboard/components/Charts/Charts';
import SleepBarChart from './SleepBarChart/SleepBarChart';
import { SleepTimeline } from './SleepTimeline/SleepTimeline';

type SleepChartProps = Omit<ChartProps, 'vitalType' | 'isLoadingData'>;

export const SleepChart: React.FC<SleepChartProps> = ({
  timeZoneId,
  personVitalInsights,
  timeFrame,
  selectedDate,
  minControlRate,
  maxControlRate,
  onDaySelect,
  onChartDataAvailabilityChange
}) => {
  return timeFrame === PersonVitalTimeFrame.TWENTY_FOUR_HOURS ? (
    <SleepTimeline
      timeZoneId={timeZoneId}
      personVitalInsights={personVitalInsights}
      timeFrame={timeFrame}
      selectedDate={selectedDate}
      minControlRate={minControlRate}
      maxControlRate={maxControlRate}
      onChartDataAvailabilityChange={onChartDataAvailabilityChange}
    />
  ) : (
    <SleepBarChart
      timeZoneId={timeZoneId}
      personVitalInsights={personVitalInsights}
      timeFrame={timeFrame}
      selectedDate={selectedDate}
      onDaySelect={onDaySelect}
      minControlRate={minControlRate}
      maxControlRate={maxControlRate}
      onChartDataAvailabilityChange={onChartDataAvailabilityChange}
    />
  );
};
